import { axiosInstance } from "@/lib/api/client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getCauseOfDamages = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/cause-of-damage`)
    .then((response) => response.data);
